export const defaultEntity = "utenti";
export const entities = ["utenti"];
export const labels = {
  utenti: "Utenti",
};
